var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHangup = function SvgHangup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "hangup")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12c-2.125 0-4.188 0.313-6.125 0.938v4.125c0 0.5-0.313 1.063-0.75 1.25-1.313 0.625-2.5 1.438-3.563 2.438-0.25 0.25-0.563 0.375-0.938 0.375s-0.688-0.125-0.938-0.375l-3.313-3.313c-0.25-0.25-0.375-0.563-0.375-0.938s0.125-0.688 0.375-0.938c4.063-3.875 9.563-6.25 15.625-6.25s11.563 2.375 15.625 6.25c0.25 0.25 0.375 0.563 0.375 0.938s-0.125 0.688-0.375 0.938l-3.313 3.313c-0.25 0.25-0.563 0.375-0.938 0.375s-0.688-0.125-0.938-0.375c-1.063-1-2.25-1.813-3.563-2.438-0.438-0.188-0.75-0.625-0.75-1.188v-4.125c-1.938-0.625-4-1-6.125-1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHangup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hangup.18e2f92a.svg";
export { ForwardRef as ReactComponent };